import { createStore as _createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import baseReducers from './Reducers/Index.js'
import Registry from './Registry/Registry'
import registryMiddleware from './Registry/Middleware'
import { createLogger } from 'redux-logger'
import persistState from 'redux-localstorage';
import storageSizeMiddleware from './StorageSizeMiddleware';

export default function createStore(initialState = {}) {
    let middleWareTools = undefined;
    //Creo redux-logger.
    const logger = createLogger({
        collapsed: true,
        level: 'log',
        diff: true
    });

    //Obtengo el registry con los reducers de Portico.
    const registry = new Registry(baseReducers);
    let middlewares = [];
    middlewares.push(registryMiddleware(registry));
    middlewares.push(thunkMiddleware);

    // if (redux_log_enabled){
    //     middlewares.push(logger);
    // }
    // if (storage_size_log_enabled){
    //     middlewares.push(storageSizeMiddleware);
    // }
    middleWareTools = compose(
        applyMiddleware(...middlewares),
        persistState(null, { key: 'atlas' })
    );

    let finalCreateStore = middleWareTools;

    const store = finalCreateStore(_createStore)(
        registry.initialReducers,
        initialState
    )

    registry.store = store

    return store
}